import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {LorenForgottenPasswordComponent} from './components/loren-forgotten-password/loren-forgotten-password.component';
import {LorenLoginGuard} from '../loren-login/guards/loren-login-guard/loren-login-guard.service';
import {LOREN_ROUTER_OUTLETS} from '../../shared/constants/loren-router-outlets.constants';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        canActivate: [
            LorenLoginGuard
        ],
        outlet: LOREN_ROUTER_OUTLETS.LOGIN,
        component: LorenForgottenPasswordComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenForgottenPasswordRoutingModule {
}
